import { FC, useCallback, useState } from 'react';
import modalClasses from '../asset/css/common-modal.module.css';

export const CommonModal: FC<{
  active: boolean;
  scrollOffset: number;
  closeFunc: () => void;
  content: JSX.Element;
}> = ({ active, scrollOffset, closeFunc, content }) => {
  const [beforeActive, setBeforeActive] = useState(false);
  const [marginTop, setMarginTop] = useState(0);

  if (beforeActive !== active) {
    setBeforeActive(active);
    if (active) {
      setMarginTop(scrollOffset + 30);
    }
  }

  const bgClickHandler = useCallback(
    (e) => {
      if (e.target.className !== modalClasses.mypage_popup_bg) return;

      closeFunc();
    },
    [closeFunc]
  );

  const closeBtnClickHandler = useCallback(() => {
    closeFunc();
  }, [closeFunc]);

  return (
    <>
      <div className={modalClasses.mypage_popup_bg} style={active ? {} : { display: 'none' }} onClick={bgClickHandler}>
        <div className={modalClasses.mypage_popup} style={{ marginTop: `${marginTop}px` }}>
          <button className={modalClasses.mypage_popup_close} onClick={closeBtnClickHandler} />
          <div className={modalClasses.mypage_popup_in}>{content}</div>
        </div>
      </div>
    </>
  );
};
